import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";

import { InstantSearch } from "./components/search";


const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "instant-search",
    additionalComponentIds: ["TagFilter"],
    includeFields: ["title", "tags", "metafields", "variants.*", "images", "media"],
    excludeFields: [],
});

const ReactifySearchProvider = ReactifySearchFactory.getProvider();
const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

ReactDOM.render(
    <React.StrictMode>
        <ReactifySearchProvider>

            <Sensors />
            <InstantSearch />
        </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
);
